module.exports = __webpack_public_path__ + "media/images/sp/stores/horie/horie_sns_03-699be41646046f960cedf27c52d22bf2.jpg";